import { LLM } from '@/types'
import i18next from 'i18next'

import { CATEGORIES } from '../categories'

const PERPLEXITY_PLATORM_LINK = 'https://docs.perplexity.ai/docs/getting-started'

const PERPLEXITY_SONAR_SMALL_ONLINE: LLM = {
  modelId: 'sonar',
  modelName: 'Sonar',
  provider: 'perplexity',
  hostedId: 'sonar',
  platformLink: PERPLEXITY_PLATORM_LINK,
  imageInput: false,
  description: () => i18next.t('models.providers.perplexity.sonar_small.description'),
  categories: [
    CATEGORIES.TECHNOLOGY,
    CATEGORIES.SCIENCE,
    CATEGORIES.ACADEMIA,
    CATEGORIES.TECHNOLOGY_WEB,
    CATEGORIES.PROGRAMMING
  ]
}

const PERPLEXITY_SONAR_LARGE_ONLINE: LLM = {
  modelId: 'sonar-pro',
  modelName: 'Sonar Pro',
  provider: 'perplexity',
  hostedId: 'sonar-pro',
  platformLink: PERPLEXITY_PLATORM_LINK,
  imageInput: false,
  tier: 'pro',
  description: () => i18next.t('models.providers.perplexity.sonar_pro.description'),
  categories: [
    CATEGORIES.TECHNOLOGY,
    CATEGORIES.SCIENCE,
    CATEGORIES.ACADEMIA,
    CATEGORIES.TECHNOLOGY_WEB,
    CATEGORIES.MARKETING_SEO,
    CATEGORIES.PROGRAMMING,
    CATEGORIES.PROGRAMMING_SCRIPTING
  ]
}

const PERPLEXITY_SONAR_HUGE_ONLINE: LLM = {
  modelId: 'sonar-reasoning',
  modelName: 'Sonar Reasoning',
  provider: 'perplexity',
  hostedId: 'sonar-reasoning',
  platformLink: PERPLEXITY_PLATORM_LINK,
  imageInput: false,
  tier: 'pro',
  description: () => i18next.t('models.providers.perplexity.sonar_reasoning.description'),
  categories: [
    CATEGORIES.TECHNOLOGY,
    CATEGORIES.SCIENCE,
    CATEGORIES.ACADEMIA,
    CATEGORIES.TECHNOLOGY_WEB,
    CATEGORIES.MARKETING_SEO,
    CATEGORIES.PROGRAMMING,
    CATEGORIES.PROGRAMMING_SCRIPTING
  ]
}

const PERPLEXITY_SONAR_REASONING_PRO: LLM = {
  modelId: 'sonar-reasoning-pro',
  modelName: 'Sonar Reasoning Pro',
  provider: 'perplexity',
  hostedId: 'sonar-reasoning-pro',
  platformLink: PERPLEXITY_PLATORM_LINK,
  imageInput: false,
  tier: 'pro',
  description: () => i18next.t('models.providers.perplexity.sonar_reasoning_pro.description'),
  categories: [
    CATEGORIES.TECHNOLOGY,
    CATEGORIES.SCIENCE,
    CATEGORIES.ACADEMIA,
    CATEGORIES.TECHNOLOGY_WEB,
    CATEGORIES.MARKETING_SEO,
    CATEGORIES.PROGRAMMING,
    CATEGORIES.PROGRAMMING_SCRIPTING,
    CATEGORIES.RESEARCH
  ]
}

const PERPLEXITY_SONAR_DEEP_RESEARCH: LLM = {
  modelId: 'sonar-deep-research',
  modelName: 'Sonar Deep Research',
  provider: 'perplexity',
  hostedId: 'sonar-deep-research',
  platformLink: PERPLEXITY_PLATORM_LINK,
  imageInput: false,
  tier: 'ultra',
  description: () => i18next.t('models.providers.perplexity.sonar_deep_research.description'),
  categories: [
    CATEGORIES.TECHNOLOGY,
    CATEGORIES.SCIENCE,
    CATEGORIES.ACADEMIA,
    CATEGORIES.RESEARCH,
    CATEGORIES.TECHNOLOGY_WEB,
    CATEGORIES.MARKETING_SEO,
    CATEGORIES.PROGRAMMING,
    CATEGORIES.PROGRAMMING_SCRIPTING
  ]
}

export const PERPLEXITY_LLM_LIST: LLM[] = [
  PERPLEXITY_SONAR_SMALL_ONLINE,
  PERPLEXITY_SONAR_LARGE_ONLINE,
  PERPLEXITY_SONAR_REASONING_PRO,
  PERPLEXITY_SONAR_DEEP_RESEARCH
]

/** @deprecated Dec 2025 — prefer sonar-reasoning-pro. Kept for old chat restores. */
export const PERPLEXITY_LEGACY_SONAR_REASONING = PERPLEXITY_SONAR_HUGE_ONLINE
